import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {Feedback} from "../../types/Feedback";
import deserializeFeedback from "./deserializers/feedback";
import {FeedbackCategory} from "../../types/FeedbackCategory";
import {FeedbackSubjectType} from "../../types/FeedbackSubjectType";
import {FeedbackType} from "../../types/FeedbackType";

// Types ----

type FeedbackCriteria = {
  types?: FeedbackType[]
  subject_type?: FeedbackSubjectType
  subject_id?: number
  authors?: number[]
  score?: number
  category?: FeedbackCategory
  has_comments?: boolean
  search?: string
  sort?: string
  page?: number
  per_page?: number
}

// Helpers ----

function criteriaToParams(criteria: FeedbackCriteria, defaults: FeedbackCriteria = {}): object {

  // Merge criteria into defaults
  const mergedCriteria = Object.assign(defaults, criteria);

  // Serialise arrays to comma-delimited strings
  return Object.fromEntries(
    Object
      .entries(mergedCriteria)
      .map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : value])
  );
}

// Requests ----

/**
 * Get all feedback that match the given criteria (paginated)
 */
async function matching(criteria: FeedbackCriteria = {}) {
  const params = criteriaToParams(criteria, {page: 1, per_page: 25});
  const response = await client.get<DataResource<Feedback> | null>('/feedback', {params})

  if (response.data) {
    response.data.data = response.data.data.map(deserializeFeedback)
  }

  return response.data
}

// Export ----

const feedback = {
    matching
}

export default feedback;